import React from 'react';
import ChartWithLegend from 'components/dynamic-page/listing-page/neighbourhood-demographics/chart-with-legend';
import Statistic from 'components/dynamic-page/listing-page/neighbourhood-demographics/statistic';
import formatCurrency from 'utils/format-currency';
import formatNumber from 'utils/format-number';
import Neighbourhood, { getNeighbourhoodDemographics } from 'data/neighbourhood';
import styles from './style.module.scss';
import LoadingData from 'components/loading-data';
import usePromise from 'hooks/use-promise';

type Props =
  | { neighbourhood: Record<string, unknown> }
  | { neighbourhoodId: number };

const Stats = ({ demographics }: { demographics: Neighbourhood }) => (
  <div className={styles.component}>
    <div className={styles.stats}>
      <Statistic value={formatCurrency(demographics.averageHouseholdIncome)!} label='Average Household Income' />
      <Statistic value={`${formatNumber(demographics.propertiesOwned)} (${demographics.propertiesOwnedPercent}%)`} label='Properties Owned' />
      <Statistic value={formatNumber(demographics.populationTotal)} label='Total Population' />
      <Statistic value={`${formatNumber(demographics.propertiesRented)} (${demographics.propertiesRentedPercent}%)`} label='Properties Rented' />
    </div>
    <ChartWithLegend title='Population by Age' data={demographics.ages} />
  </div>
);

export default function NeighbourhoodDemographics(props: Props) {
  const promise = usePromise<Neighbourhood>(async () => {
    if ('neighbourhoodId' in props) {
      const data = await getNeighbourhoodDemographics(props.neighbourhoodId);
      return new Neighbourhood(data);
    }
  });

  const intiailDemographs = ('neighbourhood' in props && props.neighbourhood) ? new Neighbourhood(props.neighbourhood) : null;
  return !intiailDemographs ? (
    <LoadingData promise={promise}>
      {demographics => (
        <Stats demographics={demographics} />
      )}
    </LoadingData>
  ) : (
    <Stats demographics={intiailDemographs} />
  );
}
